module.exports = __webpack_public_path__ + "static/media/shutterstock_2027664095.1607ba7f.jpg";